import { Box, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import { DurationType } from 'src/Enum/GoalsAndOperationalPlans';
import GoalAction from './GoalAction';
import { formatShortMonthYear } from '@Utils/datetime';
import { IIndicatorFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';

export enum GOALS_TABLE_COLUMNS {
  ID = 'id',
  GOALS = 'goals',
  DURATION_OF_OPERATION = 'durationOfOperation',
  CRITERIA = 'criteria',
  GOAL = 'goal',
  ACTION = 'action',
}

export const GOALS_VISIBILITY = {
  [GOALS_TABLE_COLUMNS.ID]: false,
};

export const goalColumns = (planIndex: number): GridColDef[] => [
  { field: GOALS_TABLE_COLUMNS.ID, headerName: 'No.' },
  {
    field: GOALS_TABLE_COLUMNS.GOALS,
    headerName: 'เป้าหมาย',
    minWidth: 175,
    flex: 1,
    renderCell: (fields) => {
      const { row, value } = fields;
      return (
        <Box>
          <Typography>{`${row.id + 1}. ${value.detailTh}`}</Typography>
          <Typography mt={2}>{`${row.id + 1}. ${value.detailEn}`}</Typography>
        </Box>
      );
    },
  },
  {
    field: GOALS_TABLE_COLUMNS.DURATION_OF_OPERATION,
    headerName: 'ระยะเวลาเป้าหมาย',
    minWidth: 175,
    flex: 1,
    renderCell: (fields) => {
      const { value } = fields;
      const formattedStartDateTh = formatShortMonthYear(
        value.startDate,
        'th-TH'
      );
      const formattedStartDateEn = formatShortMonthYear(
        value.startDate,
        'en-EN'
      );
      const formattedEndDateTh = formatShortMonthYear(value.endDate, 'th-TH');
      const formattedEndDateEn = formatShortMonthYear(value.endDate, 'en-EN');

      return (
        <Box>
          {value.durationType === DurationType.MONTH_PERIOD && (
            <Box>
              <Typography>{`${formattedStartDateTh} - ${formattedEndDateTh}`}</Typography>
              <Typography
                mt={2}
              >{`${formattedStartDateEn} - ${formattedEndDateEn}`}</Typography>
            </Box>
          )}
          {value.durationType === DurationType.WITHIN_MONTH && (
            <Box>
              <Typography>{formattedEndDateTh}</Typography>
              <Typography mt={2}>{formattedEndDateEn}</Typography>
            </Box>
          )}
        </Box>
      );
    },
  },
  {
    field: GOALS_TABLE_COLUMNS.CRITERIA,
    headerName: 'เกณฑ์การวัดผล',
    minWidth: 175,
    flex: 1,
    renderCell: (fields) => {
      const { value } = fields;
      return (
        <Box>
          <Box>
            {value.map((criteria: IIndicatorFormValues, index: number) => (
              <Typography key={`th-${index}`}>{`${index + 1}. ${
                criteria.criteriaTh
              }`}</Typography>
            ))}
          </Box>

          <Box mt={2}>
            {value.map((criteria: IIndicatorFormValues, index: number) => (
              <Typography key={`en-${index}`}>{`${index + 1}. ${
                criteria.criteriaEn
              }`}</Typography>
            ))}
          </Box>
        </Box>
      );
    },
  },
  {
    field: GOALS_TABLE_COLUMNS.ACTION,
    headerName: 'แก้ไข/ลบ',
    headerAlign: 'left',
    type: 'actions',
    minWidth: 60,
    renderCell: (params) => {
      const { id } = params;
      return <GoalAction rowId={id} planIndex={planIndex} />;
    },
  },
];
